

import NavbarDesktop from "../../../../feature/Navbar/ui/NavbarDesktop/NavbarDesktop";
import NavbarMobile from "../../../../feature/Navbar/ui/NavbarMobile/NavbarMobile";
import styles from './HeaderLinks.module.scss';


const HeaderLinks = () => {
    return ( 
     
        <div className={styles.container}>
        <div className={styles.wrapper}>
          <NavbarMobile/>
          <NavbarDesktop/>      
        </div>
    </div>
   
     );
}
 
export default HeaderLinks;